import apiClient from './ApiInterceptor';
import Moment from 'moment';

export const fetchPayments = async (startDate, endDate) => {
    try {
      const params = {};
      if (startDate) {
        params.from = Moment(startDate).format('YYYY-MM-DD');
      }
      if (endDate) {
        params.to = Moment(endDate).format('YYYY-MM-DD');
      }

        const response = await apiClient.get('/payments', { params });
        return {
            sales: response.data.sales,
            totalAmount: response.data.totalAmount,
        };
    } catch (error) {
        console.error('PaymentApi - fetchPayment, Error fetching data:', error);
    }
};

export const fetchPaymentMethods = async (active, branch) => {
    try {
        const params = {};
        if (active) {
            params.active = active;
        }
        if (branch) {
            params.branch = branch;
        }

        const response = await apiClient.get('/payments/methods', { params });
        return response.data;
    } catch (error) {
        console.error('PaymentApi - fetchPaymentMethods, Error fetching data:', error);
    }
};

export const fetchPaymentClose = async (startDate, endDate) => {
    try {
      const params = {};
      if (startDate) {
        params.from = Moment(startDate).format('YYYY-MM-DD');
      }
      if (endDate) {
        params.to = Moment(endDate).format('YYYY-MM-DD');
      }

      const response = await apiClient.get('/payments/close', { params });

      return {
        totalAmount: response.data.totalAmount,
        transactionsPerCategoryMethod: response.data.transactionsPerCategoryMethod,
        transactionsPerPaymentMethod: response.data.transactionsPerPaymentMethod
      };
    } catch (error) {
      console.error('PaymentApi - fetchPaymentClose, Error fetching data:', error);
    }
  };